<sbf-error-shell [errorNumber]="404" message1="THIS REQUESTED URL WAS NOT FOUND" message2="KEEP EXPLORING"></sbf-error-shell>
